import { Plus, X } from 'lucide-react'
import { useState } from 'react'
import { cn } from '../../utils/cn'

// Negrito inline via **...**
function rich(text) {
  return text.split('**').map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index} className="font-inter-bold">
        {part}
      </strong>
    ) : (
      part
    ),
  )
}

export default function FaqAccordion({
  intro = '',
  callout,
  eyebrow = 'EXEMPLO DE PERGUNTAS FREQUENTES',
  items = [],
  heading,
  accentBorderClass = 'border-[#FF4D1C]',
  iconClass = 'text-[#FF4D1C]',
}) {
  const [openIndex, setOpenIndex] = useState(0)

  const introParagraphs = Array.isArray(intro) ? intro : [intro]

  const toggle = index =>
    setOpenIndex(current => (current === index ? -1 : index))

  return (
    <div className="w-full px-20">
      {heading && (
        <h2 className="pb-6 font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
          {heading}
        </h2>
      )}

      {introParagraphs.some(Boolean) && (
        <div className="flex flex-col gap-4 pb-6">
          {introParagraphs.filter(Boolean).map((paragraph, index) => (
            <p
              key={index}
              className="font-inter-regular text-base leading-relaxed text-[#454545]"
            >
              {paragraph}
            </p>
          ))}
        </div>
      )}

      {callout && (
        <div className={cn('mb-6 border-l-4 pl-6', accentBorderClass)}>
          <p className="font-inter-regular text-lg leading-[1.4] tracking-[-0.02em] text-[#454545]">
            {rich(callout)}
          </p>
        </div>
      )}

      <div className="rounded-[10px] border border-[#E0E0E0] bg-[#F8F8F8] px-10 pt-[30px] pb-10">
        <span className="font-jetbrains-mono text-xs uppercase text-[#6A7282]">
          {eyebrow}
        </span>

        <ul className="mt-[13px] flex flex-col gap-6">
          {items.map((item, index) => {
            const isOpen = openIndex === index
            const isLast = index === items.length - 1

            return (
              <li
                key={index}
                className={cn(
                  'flex flex-col gap-4 pb-6',
                  !isLast && 'border-b border-[#E5E7EB]',
                )}
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => toggle(index)}
                  className="flex w-full items-start justify-between gap-6 text-left"
                >
                  <span className="font-inter-semibold text-lg leading-[28px] text-[#454545]">
                    {item.question}
                  </span>
                  {isOpen ? (
                    <X className={cn('mt-1 shrink-0', iconClass)} size={24} />
                  ) : (
                    <Plus
                      className={cn('mt-1 shrink-0', iconClass)}
                      size={24}
                    />
                  )}
                </button>

                {isOpen && item.answer && (
                  <p className="font-inter-regular text-base leading-[26px] text-[#666666]">
                    {item.answer}
                  </p>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
